import { media, style } from "typestyle";
import { colors, queries } from "styles/styles";

export const dateWrapper = style(
  {
    width: "6rem",
    height: "6rem",
    display: "flex",
    borderRadius: "9px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: colors.hooplaTextColor,
    margin: "12px 0",
    backgroundColor: "rgba(0, 0, 0, 0.05)"
  },
  media(queries.medium, {
    width: "5.5rem",
    height: "5.5rem"
  })
);

export const day = style({
  fontSize: "1.125rem"
});

export const month = style({
  textTransform: "uppercase",
  fontSize: "0.75rem",
  fontWeight: 300
});

export const year = style({
  fontSize: "0.75rem",
  fontWeight: 300
});
